import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { HpvConsentComponent } from 'src/app/screens/add-recipient/components/hpv-vaccination/hpv-consent/hpv-consent.component';
import { ImageUploadService } from '../../../services/image-upload.service';
import { UtilsService } from '../../../services/utils.service';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '../../../shared.module';
import { Capacitor } from '@capacitor/core';
import { CommonModule } from '@angular/common';
import { DownloadFileService } from '../../../services/download-file.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-photo-id-file',
  templateUrl: './photo-id-file.component.html',
  styleUrls: ['./photo-id-file.component.scss'],
})
export class PhotoIdFileComponent implements OnInit {
  @Input() fileControlName: string = 'photo_id_file';
  @Input() isDisabled: boolean = false;
  readonly imageUploadService = inject(ImageUploadService);
  readonly downloadService = inject(DownloadFileService);
  readonly util = inject(UtilsService);
  readonly sanitizer = inject(DomSanitizer);
  uploadedFileDetails: any = {};
  @Input() parentForm: FormGroup;
  @Output() onSelect = new EventEmitter();
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
  addedFile = null;
  fileBlob = null;
  fileExt: string = null;
  fileError: string | null = null;
  maxFileSize = 8 * 1024 * 1024; // 5MB in bytes

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.loadImage();
  }

  loadImage() {
    const filePath = this.parentForm.get(this.fileControlName).value;
    if (filePath) {
      this.fileExt = this.downloadService.getFileExtension(
        this.downloadService.getFileName(filePath)
      );
      const mimeType = this.downloadService.getMimeType(this.fileExt);
      this.downloadService
        .downloadFileByPath(this.parentForm.get(this.fileControlName).value)
        .subscribe((fileData: any) => {
          // this.fileBlob = fileData;
          this.fileBlob = new Blob([fileData], { type: mimeType });
          this.addedFile = this.sanitizer.bypassSecurityTrustUrl(
            window.URL.createObjectURL(this.fileBlob)
          );
          this.cdr.detectChanges();
        });
    }
  }

  downloadFile() {
    const filePath = this.parentForm.get(this.fileControlName).value;
    const fileName = this.downloadService.getFileName(filePath);
    this.downloadService.downloadFile(fileName, this.fileBlob).subscribe();
  }

  removeImage() {
    this.uploadedFileDetails = null;
    this.addedFile = null;
    this.parentForm.get(this.fileControlName).setValue(null);
  }

  uploadFile(event?) {
    if (!Capacitor.isNativePlatform() && this.onFileSelected(event)) {
      return;
    }
    console.log('##################', this.imageUploadService.imageCaptureType);
    this.imageUploadService.uploadFile(event).subscribe({
      next: (res) => {
        this.uploadedFileDetails = res;
        this.parentForm.get(this.fileControlName).setValue(res);
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.util.presentToastError(err);
      },
    });
  }
  resetFile() {
    this.fileInput.nativeElement.value = null;
  }

  async selectImageSource() {
    if (Capacitor.isNativePlatform()) {
      this.imageUploadService.selectImageSource(this.fileInput).then((r) => {
        if (this.imageUploadService.imageCaptureType == 'takePhoto') {
          console.log('111111111111111TAKEPOGOTO1111111111111');
          this.uploadFile();
        }
      });
    } else {
      this.imageUploadService.selectImageSource(this.fileInput);
    }
  }

  onFileSelected(event: Event) {
    console.log(this.imageUploadService.imageCaptureType);
    if (this.imageUploadService.imageCaptureType == 'takePhoto') {
      return false;
    }
    const input = event.target as HTMLInputElement;
    this.fileError = null;
    if (!input.files?.length) return;

    const file = input.files[0];

    if (file.size > this.maxFileSize) {
      this.fileError = 'File size should not exceed 8MB.';
    } else {
      this.fileError = null;
      // proceed with the file upload or processing
      console.log('Selected file:', file);
    }
    return this.fileError;
  }
}
